/* Winterfeldt – Schnellkauf ueber die Warenkorb-Pille auf Produktkarten.
   Legt das Produkt still in den Warenkorb: Die grosse Warenkorb-Leiste oeffnet
   sich NICHT, stattdessen zaehlt die Zahl am Warenkorb-Symbol oben hoch.
   Ist die Kopfzeile beim Runterscrollen weggefahren, erscheint stattdessen rechts oben
   fuer 2 Sekunden eine kleine Anzeige wie eine Push-Nachricht: Warenkorb-Symbol mit
   der aktuellen Anzahl (nur zur Anzeige, nicht anklickbar). Gilt auf jeder Seite mit
   Pillen, auch bei den Empfehlungen auf der Produktseite.
   - Pille bei einer Variante: <form data-wf-kauf> (snippets/wf-kauf-pille.liquid)
   - Pille bei mehreren Varianten (z. B. Farben) ist NICHT betroffen: sie oeffnet das
     Schnellkauf-Fenster des Themes, danach verhaelt sich alles wie gewohnt. */
(() => {
  if (window.__wfKauf) return;
  window.__wfKauf = true;

  const HAKEN = '<svg class="wf-kauf__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  /* Push-Anzeige rechts oben (nur wenn die Kopfzeile gerade nicht zu sehen ist) */
  const ANZEIGE_MS = 2000;
  const TASCHE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 8h12l-1.2 12H7.2z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';

  function kopfSichtbar() {
    const kopf = document.querySelector('[id*="__wf_header"]');
    if (!kopf) return false;
    return !kopf.classList.contains('wf-head--weg') && kopf.getBoundingClientRect().bottom > 10;
  }

  function anzeigeZeigen(anzahl) {
    let a = document.querySelector('.wf-push');
    if (!a) {
      a = document.createElement('div');
      a.className = 'wf-push';
      a.setAttribute('role', 'status');
      a.innerHTML = '<span class="wf-push__symbol">' + TASCHE + '<span class="wf-push__zahl"></span></span>';
      document.body.appendChild(a);
    }
    a.querySelector('.wf-push__zahl').textContent = anzahl;
    a.setAttribute('aria-label', 'Im Warenkorb: ' + anzahl + ' Artikel');
    clearTimeout(a._t);
    a.classList.remove('is-da');
    void a.offsetWidth;
    a.classList.add('is-da');
    a._t = setTimeout(() => a.classList.remove('is-da'), ANZEIGE_MS);
  }

  function zaehlerSetzen(anzahl, neu) {
    document.querySelectorAll('.wf-head__icon[href$="/cart"]').forEach((link) => {
      let z = link.querySelector('.wf-head__count');
      if (!z) {
        z = document.createElement('span');
        z.className = 'wf-head__count';
        link.appendChild(z);
      }
      z.textContent = anzahl;
      z.hidden = anzahl === 0;
      link.setAttribute('aria-label', 'Warenkorb (' + anzahl + ')');
      if (neu && anzahl > 0) {
        z.classList.remove('is-neu');
        link.classList.remove('wf-head__icon--neu');
        void z.offsetWidth;
        z.classList.add('is-neu');
        link.classList.add('wf-head__icon--neu');
        clearTimeout(link._wfNeu);
        link._wfNeu = setTimeout(() => link.classList.remove('wf-head__icon--neu'), 1400);
      }
    });
  }

  async function hinzufuegen(daten) {
    const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: daten });
    const j = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(res.status === 422 ? 'Mehr haben wir davon gerade leider nicht auf Lager.' : (j.description || j.message || 'Das hat leider nicht geklappt.'));
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    /* Kopfzeile zu sehen: dort ploppt die Zahl. Weiter unten (Kopfzeile weg): Push-Anzeige rechts. */
    if (kopfSichtbar()) {
      zaehlerSetzen(cart.item_count, true);
    } else {
      zaehlerSetzen(cart.item_count, false);
      anzeigeZeigen(cart.item_count);
    }
    /* Inhalt der Warenkorb-Leiste im Hintergrund auffrischen, ohne sie zu oeffnen */
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return cart;
  }

  function hinweis(knopf, text) {
    const karte = knopf.closest('.wf-preiszeile') || knopf.parentElement;
    let h = karte.querySelector('.wf-kauf__hinweis');
    if (!h) {
      h = document.createElement('span');
      h.className = 'wf-kauf__hinweis';
      h.setAttribute('role', 'status');
      karte.appendChild(h);
    }
    h.textContent = text;
    clearTimeout(h._t);
    h._t = setTimeout(() => { h.textContent = ''; }, 3500);
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    /* 1) Pille mit einer Variante */
    if (form.matches('[data-wf-kauf]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const knopf = form.querySelector('.wf-kauf');
      if (!knopf || knopf.getAttribute('aria-busy') === 'true') return;
      const vorher = knopf.innerHTML;
      knopf.setAttribute('aria-busy', 'true');
      try {
        await hinzufuegen(new FormData(form));
        knopf.innerHTML = HAKEN;
        knopf.classList.add('is-ok');
        setTimeout(() => { knopf.innerHTML = vorher; knopf.classList.remove('is-ok'); }, 1600);
      } catch (err) {
        hinweis(knopf, err.message);
      }
      knopf.removeAttribute('aria-busy');
    }
  }, true);
})();
